export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8995.dbb5a03c.jpg";